// extracted by mini-css-extract-plugin
export default {"inputs":"e_CqJ_OsOD0_XikHKGBm"};